import { VariableType } from 'json-to-graphql-query';

export const IdVariables = {
  id: 'Int!'
};

export const IdArgs = {
  id: new VariableType('id')
};
